import { type TypographyProps } from '@material-ui/core';

import {
  CUSTOM_BUTTON_SIZE,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
  // @ts-expect-error - CustomButton is not typed yet
} from 'src/components/CustomButton';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from '../useStyles';

interface Props {
  message: string;
  messageColor?: TypographyProps['color'];
  onBack: () => void;
}

export const ErrorCard = ({ message, messageColor = 'error', onBack }: Props) => {
  const styles = useStyles();
  return (
    <>
      <CustomTypography
        variant={TYPOGRAPHY_VARIANT.regular14}
        className={styles.body}
        color={messageColor}
      >
        {message}
      </CustomTypography>
      <CustomButton
        fullWidth
        variant={CUSTOM_BUTTON_VARIANT.outlined}
        size={CUSTOM_BUTTON_SIZE.medium}
        onClick={onBack}
        className={styles.denyButton}
      >
        Back to sign in
      </CustomButton>
    </>
  );
};
